<template>
  <div :class="{'bottom-fixed' : bottomFixed, 'simple-html5-player': true}">
    <div class="player-container">
      <div class="player">
        <audio :src="filePath" controls />
      </div>
      <div class="close">
        <button class="btn btn-ss-cancel" @click="() => requestClose()">
          <i class="la la-close" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filePath: {
      type: String,
      required: true,
    },
    bottomFixed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    requestClose() {
      this.$emit(`close-request`);
    },
  },
};
</script>

<style lang="scss" scoped>
    .simple-html5-player {
        position: fixed;
        left: 50%;
        bottom: 20px;
        transform: translate(-50%, 0%);
        margin: 0 auto;
        text-align: center;
        background-color: #FFF;
        border: 1px solid #000;
        padding: 20px;

        .player-container {
            display: flex;
            align-items: center;

            .player {
              display: flex;
            }

            .close {
              height: 40px;
              display: flex;
              justify-content: stretch;
              button {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }
            }

            .btn i {
              padding: 0;
            }
        }
    }
</style>
